
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

const ContactPage = () => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    // 폼 데이터를 URLSearchParams로 변환
    const data = new URLSearchParams();
    formData.forEach((value, key) => {
      data.append(key, value.toString());
    });

    fetch('https://readdy.ai/api/form/d5pbe34ue1sdfststj7g', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: data
    })
    .then(response => {
      if (response.ok) {
        alert('문의가 성공적으로 전송되었습니다!');
        form.reset();
      } else {
        alert('전송 중 오류가 발생했습니다. 다시 시도해주세요.');
      }
    })
    .catch(error => {
      console.error('Error:', error);
      alert('전송 중 오류가 발생했습니다. 다시 시도해주세요.');
    });
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-light text-black mb-6 leading-tight">
              Contact Us
            </h1>
            <p className="text-xl text-gray-600 font-light">
              K-뷰티 브랜드의 글로벌 진출을 함께 시작하세요
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-32 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-16">
              {/* Left: Contact Info */}
              <div className="space-y-12">
                <div>
                  <h2 className="text-4xl font-light text-black mb-8">연락처 정보</h2>
                  <p className="text-lg text-gray-600 font-light mb-12">
                    K-뷰티 브랜드의 글로벌 진출에 대한 모든 문의를 환영합니다. 
                    전문 컨설턴트가 직접 상담해드립니다.
                  </p>
                </div>
                
                <div className="space-y-8">
                  <div className="flex items-start space-x-6">
                    <div className="w-16 h-16 bg-black text-white flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-black mb-2">이메일</h3>
                      <p className="text-gray-600 mb-2">일반 문의 및 제휴 상담</p>
                      <a href="mailto:weconnect1145@gmail.com" className="text-lg text-black font-medium hover:text-gray-700 transition-colors">
                        weconnect1145@gmail.com
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-6">
                    <div className="w-16 h-16 bg-black text-white flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-line text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-black mb-2">전화</h3>
                      <p className="text-gray-600 mb-2">긴급 문의 및 직접 상담</p>
                      <a href="tel:010-3303-8802" className="text-lg text-black font-medium hover:text-gray-700 transition-colors">
                        010-3303-8802
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-6">
                    <div className="w-16 h-16 bg-black text-white flex items-center justify-center flex-shrink-0">
                      <i className="ri-time-line text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-black mb-2">운영 시간</h3>
                      <p className="text-gray-600">평일 09:00 - 18:00 (한국시간)</p>
                      <p className="text-gray-600">토요일 09:00 - 15:00</p>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Right: Contact Form */}
              <div className="bg-gray-50 p-12">
                <h3 className="text-3xl font-light text-black mb-8">제휴 문의하기</h3>
                
                <form onSubmit={handleSubmit} data-readdy-form className="space-y-6">
                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2">
                        회사명 *
                      </label>
                      <input
                        type="text"
                        id="company"
                        name="company"
                        required
                        className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent text-sm bg-white"
                      />
                    </div>
                    
                    <div>
                      <label htmlFor="contact_name" className="block text-sm font-medium text-gray-700 mb-2">
                        담당자명 *
                      </label>
                      <input
                        type="text"
                        id="contact_name"
                        name="contact_name"
                        required
                        className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent text-sm bg-white"
                      />
                    </div>
                  </div>
                  
                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                        이메일 *
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent text-sm bg-white"
                      />
                    </div>
                    
                    <div>
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                        연락처
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent text-sm bg-white"
                      />
                    </div>
                  </div>
                  
                  <div>
                    <label htmlFor="brand_name" className="block text-sm font-medium text-gray-700 mb-2">
                      브랜드명
                    </label>
                    <input
                      type="text"
                      id="brand_name"
                      name="brand_name"
                      className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent text-sm bg-white"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="inquiry_type" className="block text-sm font-medium text-gray-700 mb-2">
                      문의 유형
                    </label>
                    <select
                      id="inquiry_type"
                      name="inquiry_type"
                      className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent text-sm bg-white"
                    >
                      <option value="">선택해주세요</option>
                      <option value="partnership">브랜드 제휴</option>
                      <option value="consultation">상담 문의</option>
                      <option value="general">일반 문의</option>
                    </select>
                  </div>
                  
                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                      문의내용 *
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      rows={6}
                      required
                      maxLength={500}
                      className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent text-sm resize-none bg-white"
                      placeholder="제휴 문의 내용을 상세히 입력해주세요 (최대 500자)"
                    ></textarea>
                  </div>
                  
                  <button
                    type="submit"
                    className="w-full bg-black text-white py-4 hover:bg-gray-800 transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer flex items-center justify-center group"
                  >
                    문의 전송하기
                    <i className="ri-arrow-right-line ml-3 group-hover:translate-x-1 transition-transform duration-300"></i>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-32 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-light text-black mb-16 text-center">자주 묻는 질문</h2>
            
            <div className="space-y-8">
              <div className="bg-white p-8">
                <h3 className="text-xl font-semibold text-black mb-4">어떤 브랜드와 제휴하나요?</h3>
                <p className="text-gray-600 font-light">K-뷰티 브랜드 중 미국 시장 진출 의향이 있고, 품질과 안전성이 검증된 브랜드와 제휴합니다.</p>
              </div>
              
              <div className="bg-white p-8">
                <h3 className="text-xl font-semibold text-black mb-4">제휴 비용은 어떻게 되나요?</h3>
                <p className="text-gray-600 font-light">초기 비용 없이 매출 기반의 수수료 구조로 운영됩니다. 자세한 내용은 상담을 통해 안내드립니다.</p>
              </div>
              
              <div className="bg-white p-8">
                <h3 className="text-xl font-semibold text-black mb-4">런칭까지 얼마나 걸리나요?</h3>
                <p className="text-gray-600 font-light">브랜드 상황에 따라 다르지만, 일반적으로 계약 후 4-8주 내에 eBay 런칭이 가능합니다.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;
